import { render, staticRenderFns } from "./copyActivityLink.vue?vue&type=template&id=654be55e&scoped=true&"
import script from "./copyActivityLink.vue?vue&type=script&lang=js&"
export * from "./copyActivityLink.vue?vue&type=script&lang=js&"
import style0 from "./copyActivityLink.vue?vue&type=style&index=0&id=654be55e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654be55e",
  null
  
)

export default component.exports